var App = App || {};
App.Initialization = App.Initialization || {};

App.Initialization['widget.richText'] = (function () {
    'use strict';

    const COLLAPSED_MAX_HEIGHT_REM = 10.5;
    const RESIZE_DEBOUNCE_MS = 150;

    const initialize = (widget) => {
        if (!widget || !widget.classList.contains('rich-text--expandable')) return;

        const content = widget.querySelector('.rich-text__content') || widget;
        const button = getExpanderButton(widget);
        if (!button) return;

        const syncOverflowState = () => {
            if (!hasCollapsedOverflow(content)) {
                // Content fits — collapse silently (no animation) and hide button
                widget.style.maxHeight = '';
                widget.classList.remove('is-expanded');
                button.classList.remove('is-expanded');
                button.setAttribute('aria-expanded', 'false');
                button.hidden = true;
                return;
            }

            button.hidden = false;
        };

        button.addEventListener('click', () => {
            const isExpanded = button.classList.contains('is-expanded');
            isExpanded ? animateCollapse(widget, button) : animateExpand(widget, content, button);
        });

        let resizeTimeout;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(syncOverflowState, RESIZE_DEBOUNCE_MS);
        });

        syncOverflowState();
    };

    const getExpanderButton = (widget) => {
        const next = widget.nextElementSibling;
        if (next && next.classList.contains('rich-text__expander')) {
            return next;
        }

        return widget.parentElement?.querySelector('.rich-text__expander') || null;
    };

    const getCollapsedMaxHeightPx = () =>
        COLLAPSED_MAX_HEIGHT_REM * parseFloat(getComputedStyle(document.documentElement).fontSize);

    const hasCollapsedOverflow = (content) =>
        content.scrollHeight > (getCollapsedMaxHeightPx() + 1);

    const animateExpand = (widget, content, button) => {
        button.classList.add('is-expanded');
        button.setAttribute('aria-expanded', 'true');
        widget.classList.add('is-expanded');

        widget.style.maxHeight = content.scrollHeight + 'px';

        widget.addEventListener('transitionend', () => {
            // Remove inline style so the element isn't locked to a fixed height
            // if content changes later (e.g. images load)
            widget.style.maxHeight = 'none';
            widget.style.overflow = 'visible';
        }, { once: true });
    };

    const animateCollapse = (widget, button) => {
        button.classList.remove('is-expanded');
        button.setAttribute('aria-expanded', 'false');
        widget.classList.remove('is-expanded');

        // Pin to current rendered height so the transition has a concrete start value
        widget.style.overflow = 'hidden';
        widget.style.maxHeight = widget.scrollHeight + 'px';

        // Two rAFs ensure the browser has painted the pinned value before we change it
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                widget.style.maxHeight = getCollapsedMaxHeightPx() + 'px';

                widget.addEventListener('transitionend', () => {
                    // Hand back control to CSS
                    widget.style.maxHeight = '';
                }, { once: true });
            });
        });
    };

    return {
        initialize
    };
    
})();